const completions = new Map();
async function request(user, path, { method = "GET", body, signal } = {}) {
  const token = await user?.getIdToken?.();
  if (!token) throw new Error("Sign in to Kre8 to connect your TikTok account.");
  const base = String(process.env.REACT_APP_ENDPOINT || "").replace(/\/$/, "");
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 20000);
  try {
    const response = await fetch(`${base}/api/tiktok/${path}`, {
      method, signal: signal || controller.signal,
      headers: { Authorization: `Bearer ${token}`, ...(body ? { "Content-Type": "application/json" } : {}) },
      ...(body ? { body: JSON.stringify(body) } : {}),
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw Object.assign(new Error(data.error || "TikTok couldn't be loaded. Please try again."), { status: response.status });
    return data;
  } catch (error) {
    if (error.name === "AbortError") throw new Error("TikTok is taking a little longer. Please try again.");
    if (error instanceof TypeError) throw new Error("We couldn't connect. Check your internet connection and try again.");
    throw error;
  } finally { clearTimeout(timer); }
}
export const getTikTokStatus = (user) => request(user, "status");
export const disconnectTikTok = (user) => request(user, "connection", { method: "DELETE" });
export const fetchTikTokVideoStats = (user, cursor = "") => request(user, `videos/stats${cursor !== "" ? `?cursor=${encodeURIComponent(cursor)}` : ""}`);
export async function startTikTokConnection(user) {
  const result = await request(user, "oauth/start", { method: "POST", body: {} });
  const url = new URL(result.authUrl);
  if (url.protocol !== "https:" || url.hostname !== "www.tiktok.com" || !/^\/v2\/auth\/authorize\/?$/.test(url.pathname)) throw new Error("TikTok couldn't start a secure connection. Please try again.");
  window.location.assign(url.toString());
}
export function completeTikTokConnection(user, handoff) {
  const key = `${user?.uid}:${handoff}`;
  if (!completions.has(key)) {
    if (completions.size >= 10) completions.delete(completions.keys().next().value);
    completions.set(key, request(user, "oauth/complete", { method: "POST", body: { handoff } }));
  }
  return completions.get(key);
}
